import { Location, NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IconComponent } from '../icons';

@Component({
  selector: 'ui-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconComponent, NgClass, NgIf],
})
export class PageHeaderComponent {
  @Input() parentPath = '';
  @Input() navigateBack = true;

  constructor(
    private location: Location,
    private router: Router
  ) {}

  goBack() {
    if (this.parentPath) {
      this.router.navigate([this.parentPath], { replaceUrl: true });
    } else {
      this.location.back();
    }
  }
}
